<script setup>
  import {ref} from "vue";

  import ComponentIcon from "@components/Icons/Icon.vue";

  defineOptions({
    name: "ContactsContactHead",
  });

  const props = defineProps({
    modelValue: {
      type: String,
      required: true,
    },
  });

  const emit = defineEmits(["update:modelValue"]);

  const order = ref(props.modelValue || "");

  function orderBy(by) {
    if (order.value.includes(by)) {
      // already sorted by this colum, so flip direction
      if (by.slice(0, 1) === "-") {
        // asc
        order.value = by.slice(1); // remove "-"
      } else {
        // desc
        order.value = "-" + by; // add "-"
      }
    } else {
      // not already sorted by this column, asc is default
      order.value = by;
    }

    emit("update:modelValue", order.value);
  }
</script>

<template>
  <tr class="border-b-2 border-gray-400 leading-tight">
    <th class="px-0.5 py-2 text-left align-top font-normal">
      <div class="text-xs">Fachrichtung</div>

      <div>
        <button
          class="flex items-center space-x-2 text-left"
          :data-test="getTestId('contact-head-sort-lastname')"
          @click.prevent="orderBy('-lastname')"
        >
          <span>Nachname, Vorname</span>
          <ComponentIcon v-if="!order.includes('lastname')">unfold_more</ComponentIcon>
          <ComponentIcon v-if="order === 'lastname'">expand_less</ComponentIcon>
          <ComponentIcon v-if="order === '-lastname'">expand_more</ComponentIcon>
        </button>
      </div>
    </th>

    <th class="px-0.5 py-2 text-left align-top font-normal">Firma / Praxisname</th>

    <th class="px-0.5 py-2 text-left align-top font-normal">Information</th>

    <th class="hidden px-0.5 py-2 text-left align-top font-normal 2xl:table-cell">E-Mail</th>

    <th class="hidden px-0.5 py-2 text-left align-top font-normal 2xl:table-cell">Tel.-Nr.</th>

    <th class="hidden px-0.5 py-2 text-left align-top font-normal lg:table-cell">
      <button
        class="flex items-center space-x-2 text-left"
        :data-test="getTestId('contact-head-sort-city')"
        @click.prevent="orderBy('-city')"
      >
        <span>Adresse</span>
        <ComponentIcon v-if="!order.includes('city')">unfold_more</ComponentIcon>
        <ComponentIcon v-if="order === 'city'">expand_less</ComponentIcon>
        <ComponentIcon v-if="order === '-city'">expand_more</ComponentIcon>
      </button>
    </th>

    <th class="w-28"><!-- actions --></th>
  </tr>
</template>
